import { TableHeaderColumnType } from "app/components/Table/types";

export const TableHeaderDefinition = {
  CUSTOMER_ID: {
    id: "_id",
    label: 'CUSTOMER_ID',
    format: (value) => value,
    maxWidth: 120,
    minWidth: 120,
    sortable:false
  },
  REGISTRATION_DATE: {
    id: "createdAt",
    label: 'REGISTRATION_DATE',
    format: (value) => value,
    maxWidth: 160,
    minWidth: 160,
    sortable:true
  },
  LAST_PURCHASE_DATE: {
    id: "updatedAt",
    label: 'LAST_PURCHASE_DATE',
    format: (value) => value,
    maxWidth: 170,
    minWidth: 170,
    sortable:true
  },
  CUSTOMER_NAME: {
    id: "name",
    label: 'CUSTOMER_NAME',
    format: (value) => value,
    maxWidth: 200,
    minWidth: 200,
    sortable:true
  },
  MOBILE_NUMBER: {
    id: "mobileNumber",
    label: 'MOBILE_NUMBER',
    format: (value) => value,
    maxWidth: 150,
    minWidth: 150,
    sortable:true
  },
  EMAIL: {
    id: "email",
    label: 'EMAIL',
    format: (value) => value,
    maxWidth: 200,
    minWidth: 200,
    sortable:true
  },
  NUMBER_OF_PURCHASED_GAMES: {
    id: "numberOfPurchasedGames",
    label: 'NUMBER_OF_PURCHASED_GAMES',
    format: (value) => value,
    maxWidth: 150,
    minWidth: 150,
    sortable:true
  },
  NUMBER_OF_PLAYED_GAMES: {
    id: "noOfPlayedGames",
    label: 'NUMBER_OF_PLAYED_GAMES',
    format: (value) => value,
    maxWidth: 150,
    minWidth: 150,
    sortable:true
  }
};

export const TableHeaders: TableHeaderColumnType[] = Object.values(
  TableHeaderDefinition
);